module.exports = __webpack_public_path__ + "img/k06.4b8d212f.png";